export default {
  emailOrPhone: 'E-mail ou telefone',
  password: 'Senha',
  rememberMe: 'Lembre-se de mim.',
  forgotYourPassword: 'Esqueceu sua senha?',
  signIn: 'Entrar',
  newHere: 'Novo Aqui?',
  openAccount: 'Abra uma conta',
  haveAccount: 'Já tem uma conta?',
  fullName: 'Nome completo',
  country: 'País',
  phone: 'Telefone',
  email: 'Email',
  iAgree: 'Eu concordo com o',
  termsAndConditions: 'Acordo de termos e condições',
  signUp: 'Inscrição',
  recoverPassword: 'Recupere sua senha',
  recover: 'Recuperar',
  goBack: 'Voltar',
  weHaveSentYouACode: 'Nós enviamos um código para o seu',
  receivedCode: 'Código recebido',
  newPassword: 'Nova senha',
  confirmNewPassword: 'Confirme sua nova senha',
  passwordSuccessfullyChanged: 'Senha alterada com sucesso'
}
